module.exports = new __parcel__URL__("tallyho.56ec6262.svg").toString();